import { ReactNode } from 'react';
import styled, { css } from 'styled-components/macro';

const Container = styled.div`
  display: inline-flex;
  width: 100%;
`;

const IndexContainer = styled.div`
  width: 16px;
`;

const H5 = styled.h5`
  position: relative;
  width: 32px;
  height: 32px;
  margin: 0;
  border-radius: 32px;
  border: 2px solid #646974;
  text-align: center;
  padding-top: 5px;
  background-color: #fff;
`;

const ItemBody = styled.div<{ noMargin: boolean }>`
  flex: 1;
  padding-left: 40px;
  border-left: 2px solid #646974;
  line-height: 24px;
  p {
    margin: 0;
  }
  p + p {
    margin-bottom: 48px;
  }
  ${({ noMargin }) =>
    noMargin
      ? css`
          border-left: none;
        `
      : ''}
`;

const Title = styled.p`
  font-weight: bold;
  padding-bottom: 8px;
`;

const H3 = styled.h3`
  margin-bottom: 24px;
`;

export interface NextStepItem {
  title: string;
  description: string | ReactNode;
}

type NextStepItemProps = NextStepItem & {
  index: number;
  noMargin: boolean;
};

const Item = ({ title, description, index, noMargin }: NextStepItemProps) => {
  return (
    <Container>
      <IndexContainer>
        <H5>{index + 1}</H5>
      </IndexContainer>
      <ItemBody noMargin={noMargin}>
        <Title>{title}</Title>
        {typeof description === 'string' ? <p>{description}</p> : description}
      </ItemBody>
    </Container>
  );
};

export interface NextStepsProps {
  title?: string;
  items: NextStepItem[];
}

export const NextSteps = ({ items, title }: NextStepsProps) => {
  return (
    <>
      {title && <H3>{title}</H3>}
      {items.map((item, index) => (
        <Item key={index} index={index} {...item} noMargin={index === items.length - 1} />
      ))}
    </>
  );
};
